module.exports = __webpack_public_path__ + "img/goal-progress.95356baa.svg";